module.exports = __webpack_public_path__ + "static/media/time_white.227eb77e.svg";